export var createPIIExcludedLeadLog = function (lead) { return ({
    leadHasMobileNumber: Boolean('mobileNumber' in lead && (lead === null || lead === void 0 ? void 0 : lead.mobileNumber)),
    leadHasEmail: Boolean('email' in lead && (lead === null || lead === void 0 ? void 0 : lead.email)),
    leadHasAccountOrigin: Boolean('accountOrigin' in lead && (lead === null || lead === void 0 ? void 0 : lead.accountOrigin)),
    leadHasFirstName: Boolean('firstName' in lead && (lead === null || lead === void 0 ? void 0 : lead.firstName)),
    leadHasLastName: Boolean('lastName' in lead && (lead === null || lead === void 0 ? void 0 : lead.lastName)),
    generatedAt: lead === null || lead === void 0 ? void 0 : lead.generatedAt,
    customerId: lead === null || lead === void 0 ? void 0 : lead.customerId,
    brand: lead === null || lead === void 0 ? void 0 : lead.brand,
    utm: lead === null || lead === void 0 ? void 0 : lead.utm,
    origin: lead === null || lead === void 0 ? void 0 : lead.origin,
    timeZone: lead === null || lead === void 0 ? void 0 : lead.timeZone,
    storeId: lead === null || lead === void 0 ? void 0 : lead.storeId,
    ownerId: lead === null || lead === void 0 ? void 0 : lead.ownerId,
    gclId: lead === null || lead === void 0 ? void 0 : lead.gclId,
}); };
//# sourceMappingURL=index.js.map